(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "+2Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMAINING_STOCK_LIMIT; });
var REMAINING_STOCK_LIMIT = 10;

/***/ }),

/***/ "+wNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ "/1vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return popinTypes; });
var popinTypes = {
  VIEW: 'view',
  OUTSIDE_FACILITIES: 'outsideFacilities',
  ROOM_TYPE: 'roomType'
};

/***/ }),

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);





var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'seasons', []);

  return seasons.length === 1 && seasons.includes('WINTER') && lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "3dHC":
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackErrorOnAddService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPdfName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleWrongUrl; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zytj");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("1qsz");




















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_21__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* hasChildcare */ "s"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* hasTransfer */ "v"])(selectedProposal) && !lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere,
      _ref$isPartiallyPaid = _ref.isPartiallyPaid,
      isPartiallyPaid = _ref$isPartiallyPaid === void 0 ? false : _ref$isPartiallyPaid;
  var bankingStep = {
    name: 'banking',
    eventPageName: 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: 'banking',
    agenceType: isSeller && isDelCredere ? 'Ducroire' : 'NonDucroire',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title,
    gridSize: isSeller ? 'large' : ''
  };

  if (isPartiallyPaid) {
    // the proposals should not be modified after an household has already paid
    return [bankingStep];
  }

  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* isRecommendedTransport */ "D"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_27__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;

  var isJoyview = lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(resort, 'isJoyview');

  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__[/* tAlt */ "p"])({
      resortKeyPath: isSeller ? 'booking.partners.accommodation.pageTitle' : 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_23__[/* getTransportIcon */ "h"])(lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(selectedProposal, 'transports.inbound'), lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(selectedProposal, 'transports.outbound')),
    // eslint-disable-next-line no-nested-ternary
    title: isRecommendedTransportSelected ? isSeller ? i18n.booking.partners.transport.transportPageTitle : i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRANSFER,
    title: isSeller ? i18n.booking.partners.transport.transferPageTitle : i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: isCmta ? Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.partners.summary.pageTitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];

  if (activitiesView) {
    breadcrumbPages.splice(3, 0, activitiesView);
  } // adds the banking step if the optionHoldOnly featureFlip is disabled


  if (!isOptionHoldOnlyFeatureFlipped) {
    breadcrumbPages.push(bankingStep);
  } // $FlowFixMe Absolutely no clue of why


  return lodash_reject__WEBPACK_IMPORTED_MODULE_17___default()(breadcrumbPages, 'isToBeHidden');
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var trackErrorOnAddService = function trackErrorOnAddService(error, trackCallback, defaultValue) {
  if (error) {
    var _error$errors, _error$errors$, _error$errors$$respon, _error$errors$$respon2, _error$errors$$respon3;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : (_error$errors$$respon = _error$errors$.responseBody) === null || _error$errors$$respon === void 0 ? void 0 : (_error$errors$$respon2 = _error$errors$$respon.errors) === null || _error$errors$$respon2 === void 0 ? void 0 : (_error$errors$$respon3 = _error$errors$$respon2[0]) === null || _error$errors$$respon3 === void 0 ? void 0 : _error$errors$$respon3.error_code;
    trackCallback({
      labelGA: "error_".concat(errorCode ? errorCode : defaultValue)
    });
  }
};
var getPdfName = function getPdfName(resort, proposal) {
  var _resort$name;

  return "".concat(resort === null || resort === void 0 ? void 0 : (_resort$name = resort.name) === null || _resort$name === void 0 ? void 0 : _resort$name.replace(/ /g, '_'), "-").concat(proposal === null || proposal === void 0 ? void 0 : proposal.arrivalDate, "_").concat(proposal === null || proposal === void 0 ? void 0 : proposal.departureDate);
};
var handleWrongUrl = function handleWrongUrl(router) {
  var _router$query, _router$query2, _router$query3;

  var proposalIds = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.proposalIds;
  var bookingStep = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.bookingStep;
  var date = (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.date;
  var today = new Date();
  var isExpiredDate = moment__WEBPACK_IMPORTED_MODULE_20___default()(date).isBefore(moment__WEBPACK_IMPORTED_MODULE_20___default()(today), 'day');

  if (!router.query || !proposalIds || proposalIds.length < 1 || !bookingStep || isExpiredDate) {
    // If the url misses proposalsIds or bookingStep, or has a date in the past
    // then, we should redirect to homepage instead of throwing a 500 error
    _logger_logger__WEBPACK_IMPORTED_MODULE_19__["default"].error('If the url misses proposalsIds or bookingStep, or has a date in the past, then we should redirect to homepage instead of throwing a 500 error');
    router.push('/');
    throw new Error('Invalid booking paramerter');
  }
};

/***/ }),

/***/ "54uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ACTIVATED; });
/* unused harmony export API_EDITABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_UNAVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOTYET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_UNEDITABLE; });
/* unused harmony export API_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_UPSELL_AVAILABLE; });
/* unused harmony export API_RESORT_ONLY_FORM_SENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_DONE; });
var API_AVAILABLE = 'AVAILABLE';
var API_VALIDATED = 'VALIDATED';
var API_ACTIVATED = 'ACTIVATED';
var API_EDITABLE = 'EDITABLE';
var API_UNAVAILABLE = 'UNAVAILABLE';
var API_NOTYET = 'NOT_YET';
var API_UNEDITABLE = 'UNEDITABLE';
var API_OPTION = 'OPTION';
var API_RESORT_ONLY = 'RESORT_ONLY';
var API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
var API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
var API_DONE = 'DONE';


/***/ }),

/***/ "8K1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XcBm");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "9fIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "HbGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("+wNj");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "K/z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("T0aG");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pWxA");


function _possibleConstructorReturn(self, call) {
  if (call && (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "MMYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ "OOYD":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("W0vE"),
    baseFilter = __webpack_require__("sjzV"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD"),
    negate = __webpack_require__("J4/4");

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ "OsvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NO_VIEW_ICON_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_OUTSIDE_FACILITY_ICON_ID; });
/* unused harmony export roomTypeIcons */
/* unused harmony export viewIcons */
/* unused harmony export outsideFacilitiesIcons */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isRoomTypeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isViewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isOutsideFacilityItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isItemFilterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addViewIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addOutsideFacilitiesIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addRoomTypeIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTypedFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasTypedAlternative; });
/* unused harmony export submitAccommodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return chooseOption; });
/* unused harmony export DefaultAccommodationFilterRadioButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultAccommodationViewRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAccommodationOutsideFacilitiesRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultAccommodationRoomTypeRadioButton; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("dm5U");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SPKZ");
/* harmony import */ var _accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("cb6o");
/* harmony import */ var _store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("AnR0");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("47Eh");
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("UIAR");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("/1vS");















var __jsx = react__WEBPACK_IMPORTED_MODULE_15___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var NO_VIEW_ICON_ID = 'no_view';
var NO_OUTSIDE_FACILITY_ICON_ID = 'no_outside_facility';
var roomTypeIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SINGLE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SUITE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SEPARATE_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SEPARATE_ROOMS_3, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].CONNECTING_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SEPARATED_BUILDINGS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].separate_rooms, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].SHARED_ROOM];
var viewIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].fir_tree_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].pool_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].mountain_view_or_slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].river_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].sea_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].seaview, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].garden_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].mountain_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].forest_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].golf_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].valley_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].view_chailifts_or_cable_railway, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].view_of_the_grounds, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].view_of_the_ski_resort];
var outsideFacilitiesIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].Balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].furnished_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].double_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].private_furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].private_garden, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].private_pool, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].with_balcony_or_resort_view]; //used to identify the type of each item on accommodationRoomInfos

var isRoomTypeItem = function isRoomTypeItem(itemIcon) {
  return roomTypeIcons.includes(itemIcon);
};
var isViewItem = function isViewItem(itemIcon) {
  return viewIcons.includes(itemIcon);
};
var isOutsideFacilityItem = function isOutsideFacilityItem(itemIcon) {
  return outsideFacilitiesIcons.includes(itemIcon);
};
var isItemFilterable = function isItemFilterable(itemIcon) {
  return isRoomTypeItem(itemIcon) || isViewItem(itemIcon) || isOutsideFacilityItem(itemIcon);
};
var addViewIconPropertiesToFilters = function addViewIconPropertiesToFilters(filtersView) {
  return filtersView === null || filtersView === void 0 ? void 0 : filtersView.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getViewIconItem */ "h"])({
        id: filter.id,
        label: filter.label
      })
    });
  });
};
var addOutsideFacilitiesIconPropertiesToFilters = function addOutsideFacilitiesIconPropertiesToFilters(outsideFacilitiesFilter) {
  return outsideFacilitiesFilter === null || outsideFacilitiesFilter === void 0 ? void 0 : outsideFacilitiesFilter.map(function (filter) {
    var accommodationOutsideFacility = [{
      id: filter.id,
      label: filter.label
    }];
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getOutsideFacilitiesIconItem */ "f"])(accommodationOutsideFacility)
    });
  });
};
var addRoomTypeIconPropertiesToFilters = function addRoomTypeIconPropertiesToFilters(filtersRoomType, resort) {
  return filtersRoomType === null || filtersRoomType === void 0 ? void 0 : filtersRoomType.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getSurfaceIconItem */ "g"])(filter.id, resort, '')
    }); //filter.surface
  });
};
var getTypedFilters = function getTypedFilters(_ref, type) {
  var filtersView = _ref.filtersView,
      filtersOutsideFacilities = _ref.filtersOutsideFacilities,
      filtersRoomType = _ref.filtersRoomType;

  switch (type) {
    case _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].VIEW:
      return filtersView || [];

    case _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].OUTSIDE_FACILITIES:
      return filtersOutsideFacilities || [];

    case _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].ROOM_TYPE:
      return filtersRoomType || [];

    default:
      return [];
  }
};
var hasTypedAlternative = function hasTypedAlternative(_ref2) {
  var _currentComfortAltern, _currentComfortAltern2, _currentComfortAltern3;

  var currentComfortAlternatives = _ref2.currentComfortAlternatives,
      icon = _ref2.icon,
      proposal = _ref2.proposal;
  var viewAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern === void 0 ? void 0 : _currentComfortAltern.view;
  var outsideFacilityAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern2 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern2 === void 0 ? void 0 : _currentComfortAltern2.outsideFacilities;
  var roomTypeAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern3 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern3 === void 0 ? void 0 : _currentComfortAltern3.roomType;

  if (isViewItem(icon) && viewAlternatives) {
    var _proposal$accommodati, _proposal$accommodati2;

    var viewAlternativeExceptNoView = viewAlternatives.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== NO_VIEW_ICON_ID;
    });
    var proposalCurrentViewId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati = proposal.accommodations[0]) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati.view) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.id;
    var pureViewAlternatives = proposalCurrentViewId ? viewAlternatives.filter(function (_ref4) {
      var id = _ref4.id;
      return id !== proposalCurrentViewId;
    }) : viewAlternativeExceptNoView;
    return pureViewAlternatives.length >= 1;
  }

  if (isOutsideFacilityItem(icon) && outsideFacilityAlternatives) {
    var _proposal$accommodati3, _proposal$accommodati4, _proposal$accommodati5;

    var outsideFacilityAlternativesExceptNoOF = outsideFacilityAlternatives.filter(function (_ref5) {
      var id = _ref5.id;
      return id !== NO_OUTSIDE_FACILITY_ICON_ID;
    });
    var proposalCurrentOutsideFacilityId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati3 = proposal.accommodations[0]) === null || _proposal$accommodati3 === void 0 ? void 0 : (_proposal$accommodati4 = _proposal$accommodati3.outsideFacilities) === null || _proposal$accommodati4 === void 0 ? void 0 : (_proposal$accommodati5 = _proposal$accommodati4[0]) === null || _proposal$accommodati5 === void 0 ? void 0 : _proposal$accommodati5.id; //remove same id option if necessary

    var pureOutsideFacilityAlternatives = proposalCurrentOutsideFacilityId ? outsideFacilityAlternatives.filter(function (_ref6) {
      var id = _ref6.id;
      return id !== proposalCurrentOutsideFacilityId;
    }) : outsideFacilityAlternativesExceptNoOF;
    return pureOutsideFacilityAlternatives.length >= 1;
  }

  if (isRoomTypeItem(icon) && roomTypeAlternatives) {
    var _proposal$accommodati6; //there is always a roomType


    var proposalCurrentRoomTypeId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati6 = proposal.accommodations[0]) === null || _proposal$accommodati6 === void 0 ? void 0 : _proposal$accommodati6.roomType; //remove same id option if necessary

    var pureRoomTypeAlternatives = proposalCurrentRoomTypeId ? roomTypeAlternatives.filter(function (_ref7) {
      var id = _ref7.id;
      return id !== proposalCurrentRoomTypeId;
    }) : roomTypeAlternatives;
    return pureRoomTypeAlternatives.length >= 1;
  }
};
var submitAccommodation = function submitAccommodation(_ref8) {
  var accommodationsSets = _ref8.accommodationsSets,
      proposal = _ref8.proposal,
      formSelectedAlternativeId = _ref8.formSelectedAlternativeId,
      resort = _ref8.resort,
      dispatch = _ref8.dispatch,
      appContext = _ref8.appContext,
      onClose = _ref8.onClose;
  var selectedAccommodationSet = accommodationsSets === null || accommodationsSets === void 0 ? void 0 : accommodationsSets.find(function (_ref9) {
    var id = _ref9.id;
    return id === formSelectedAlternativeId;
  });
  return function () {
    var _selectedAccommodatio, _selectedAccommodatio2;

    if (!formSelectedAlternativeId) {
      return onClose();
    } //get the arrangement


    var arrangement = selectedAccommodationSet === null || selectedAccommodationSet === void 0 ? void 0 : (_selectedAccommodatio = selectedAccommodationSet.accommodations) === null || _selectedAccommodatio === void 0 ? void 0 : (_selectedAccommodatio2 = _selectedAccommodatio.map(function (_ref10) {
      var attendeesDistribution = _ref10.attendeesDistribution;
      return attendeesDistribution;
    })) === null || _selectedAccommodatio2 === void 0 ? void 0 : _selectedAccommodatio2.filter(Boolean);
    arrangement && dispatch(Object(_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_19__[/* addAccommodation */ "a"])({
      arrangement: arrangement,
      globalLoaderLabel: '',
      toastLabel: '',
      isJoyview: resort.isJoyview,
      proposalsId: Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_20__[/* getAllProposalsIdWithAlternative */ "a"])(proposal),
      appContext: appContext,
      reduxAction: _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_21__[/* ADD_ACCOMMODATION_FROM_ALTERNATIVES */ "c"]
    })).then(function () {
      //switch offers maybe ( Warning )
      return onClose();
    });
  };
};
var chooseOption = function chooseOption(_ref11) {
  var appContext = _ref11.appContext,
      formik = _ref11.formik,
      filters = _ref11.filters,
      accommodationsSets = _ref11.accommodationsSets,
      proposal = _ref11.proposal,
      resort = _ref11.resort,
      dispatch = _ref11.dispatch,
      onClose = _ref11.onClose; //set the alternative

  var selectedOptionValueId = formik.values.selectedFilterValueId;
  var selectedOption = filters.find(function (_ref12) {
    var id = _ref12.id;
    return id === selectedOptionValueId;
  });

  if (selectedOption && selectedOption.firstAlternativeId) {
    var selectedOptionFirstAlternativeId = selectedOption.firstAlternativeId;
    submitAccommodation({
      accommodationsSets: accommodationsSets,
      proposal: proposal,
      formSelectedAlternativeId: selectedOptionFirstAlternativeId,
      resort: resort,
      dispatch: dispatch,
      appContext: appContext,
      onClose: onClose
    })();
  }
};
var DefaultAccommodationFilterRadioButton = function DefaultAccommodationFilterRadioButton(_ref13) {
  var _accommodationIconPro, _accommodationIconPro2;

  var accommodationIconProps = _ref13.accommodationIconProps,
      value = _ref13.value;
  return __jsx("li", {
    key: 0,
    style: {
      flexBasis: '21%'
    }
  }, __jsx(_radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_16__[/* RadioButtonWithIcon */ "a"], {
    name: "selectedFilterValueId",
    title: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro = accommodationIconProps.labels) === null || _accommodationIconPro === void 0 ? void 0 : _accommodationIconPro[0]) || '',
    description: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro2 = accommodationIconProps.labels) === null || _accommodationIconPro2 === void 0 ? void 0 : _accommodationIconPro2[1]) || '',
    value: value,
    priceDifference: "",
    icon: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : accommodationIconProps.icon) || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].TRIDENT
  }));
};
var getTitle = function getTitle(type) {
  if (type === _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].VIEW) {
    return 'booking.accommodation.roomFinder.viewFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].OUTSIDE_FACILITIES) {
    return 'booking.accommodation.roomFinder.facilitiesFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_22__[/* popinTypes */ "a"].ROOM_TYPE) {
    return 'booking.accommodation.roomFinder.roomConfigurationFilterTitle';
  }

  return 'booking.accommodation.roomFinder.filtersTitle';
};
var DefaultAccommodationViewRadioButton = function DefaultAccommodationViewRadioButton(_ref14) {
  var defaultAccommodationViewIcon = _ref14.defaultAccommodationViewIcon,
      value = _ref14.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationViewIcon,
    value: value
  });
};
var DefaultAccommodationOutsideFacilitiesRadioButton = function DefaultAccommodationOutsideFacilitiesRadioButton(_ref15) {
  var defaultAccommodationOutsideFacilitiesIcon = _ref15.defaultAccommodationOutsideFacilitiesIcon,
      value = _ref15.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationOutsideFacilitiesIcon,
    value: value
  });
};
var DefaultAccommodationRoomTypeRadioButton = function DefaultAccommodationRoomTypeRadioButton(_ref16) {
  var defaultAccommodationRoomTypeIcon = _ref16.defaultAccommodationRoomTypeIcon,
      value = _ref16.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationRoomTypeIcon,
    value: value
  });
};

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "T0aG":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "W0vE":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "XcBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "aPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendErrorToSentry; });
/* unused harmony export shouldIgnore */
/* unused harmony export processError */
/* unused harmony export handleBrowserError */
/* unused harmony export handlePromiseError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleComponentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return start; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wNDy");













var sanitize = function sanitize() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return s && s.trim().toLowerCase();
};

var sendErrorToSentry = function sendErrorToSentry(_ref) {
  var error = _ref.error,
      _ref$errorInfo = _ref.errorInfo,
      errorInfo = _ref$errorInfo === void 0 ? {} : _ref$errorInfo;

  if ( true && _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.sentry.enabled')) {
    var _window$Sentry;

    (_window$Sentry = window.Sentry) === null || _window$Sentry === void 0 ? void 0 : _window$Sentry.withScope(function (scope) {
      var _window$Sentry2;

      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      (_window$Sentry2 = window.Sentry) === null || _window$Sentry2 === void 0 ? void 0 : _window$Sentry2.captureException(error);
    });
  }
};
var shouldIgnore = function shouldIgnore(error) {
  var errorMessagesToIgnore = [].concat(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.ignore.descriptions'));
  var errorMessage = sanitize(error.message);
  var errorStack = sanitize(error.stack);
  return errorMessagesToIgnore.some(function (messageToIgnore) {
    var msg = sanitize(messageToIgnore);
    var isIgnored = !!msg && (!!errorMessage.includes(msg) || !!errorStack.includes(msg));
    return isIgnored;
  });
};
var processError = function processError(_ref2) {
  var error = _ref2.error,
      errorInfo = _ref2.errorInfo;
  _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error({
    err: error,
    info: errorInfo
  });

  if (!shouldIgnore(error)) {
    sendErrorToSentry({
      error: error,
      errorInfo: errorInfo
    });
  }

  return error;
}; // eslint-disable-next-line max-params

var handleBrowserError = function handleBrowserError(message, file, line, col, error) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown error name',
      message: message || 'Unknown error message',
      stack: 'Unknown stack'
    }),
    errorInfo: {
      message: message,
      file: file,
      line: line,
      col: col
    }
  });
};
var handlePromiseError = function handlePromiseError(domCustomEvent) {
  return processError({
    error: lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'detail.reason', lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'reason', new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown rejected promise name',
      message: 'Unknown rejected promise message',
      stack: ['Unknown stack']
    })))
  });
};
var handleComponentError = function handleComponentError(error, errorInfo) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown component error name',
      message: 'Unknown component error message',
      stack: ['Unknown stack']
    }),
    errorInfo: errorInfo
  });
};
var start = function start() {
  window.onerror = handleBrowserError;
  window.addEventListener('unhandledrejection', handlePromiseError);
  window.addEventListener('rejectionhandled', handlePromiseError);
};

/***/ }),

/***/ "aWOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ hasSomeUpsellsAlreadyPaid; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ bookingUtils_mapBookingEntity; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ bookingUtils_isEasyArrivalEnabled; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ bookingUtils_isEasyCheckInOutEnabled; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ bookingUtils_isEasyTransferEnabled; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ hasActivitiesUpsellsEnabled; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ hasServicesUpsellsEnabled; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ hasWhiteLabelServicesUpsellsEnabled; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bookingUtils_getCGVFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ bookingUtils_getHealthRegulationsFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ bookingUtils_tAlt; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ bookingUtils_getActivityTypeName; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bookingUtils_getBookingEngineUrl; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ isOptionAboutToExpire; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ bookingUtils_getStaffChief; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ bookingUtils_getStaffCategories; });

// UNUSED EXPORTS: hasActivitiesType

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("TYRa");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("+2Ph");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var constants = __webpack_require__("54uq");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var booking_process_constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/booking-status/bookingStatus.constants.js
var bookingStatus_constants = __webpack_require__("blgx");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/utils/legacy-booking-engine/legacyBookingUrlBuilder.js





/* eslint-disable flowtype/no-weak-types */



function buildProposalUrl(_ref) {
  var productId = _ref.productId,
      proposalId = _ref.proposalId,
      currentUri = _ref.currentUri,
      fromSearches = _ref.fromSearches;
  var redirectionQueryParameters = {
    proposalIds: proposalId,
    selectedProposalId: proposalId,
    product: productId,
    coderesort: productId,
    fromSearches: fromSearches
  };
  var uri = new URI_default.a(currentUri);
  var queryParams = URI_default.a.parseQuery(uri.search());

  if (queryParams.locale) {
    // $FlowFixMe
    redirectionQueryParameters.locale = queryParams.locale;
  } // $FlowFixMe


  return uri.segment([config_default.a.get('booking.endpoints.responsive')]).query(redirectionQueryParameters).toString();
}

function buildUrlFromContextNumber(formData, appContext, currentUri) {
  return buildProposalUrl({
    appContext: appContext,
    productId: formData.resortId,
    proposalId: formData.reference,
    fromSearches: formData.fromSearches,
    currentUri: currentUri
  });
}


// CONCATENATED MODULE: ./src/utils/upsells/upsells.constants.js
var UPSELL_ACTIVITY_TYPE_EXCURSION = 'EXCURSION';
var UPSELL_ACTIVITY_TYPE_LANDSPORT = 'LAND_SPORT';
var UPSELL_ACTIVITY_TYPE_WATERSPORT = 'WATER_SPORT';
var UPSELL_ACTIVITY_TYPE_WELLNESS = 'WELLNESS';
var UPSELL_ACTIVITY_TYPE_WINTERSPORT = 'WINTER_SPORT';
// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingUtils.js

























function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    WINTER_MOUNTAIN_RESORT = dist["constants"].WINTER_MOUNTAIN_RESORT;
var hasActivitiesType = function hasActivitiesType(booking, type) {
  var _booking$information, _booking$information$;

  return (((_booking$information = booking.information) === null || _booking$information === void 0 ? void 0 : (_booking$information$ = _booking$information.additionalServices) === null || _booking$information$ === void 0 ? void 0 : _booking$information$.activities) || []).some(function (_ref) {
    var pricingInfo = _ref.pricingInfo;
    return pricingInfo && pricingInfo.type === type;
  });
};

var hasUpsellsEnabled = function hasUpsellsEnabled(_ref2) {
  var booking = _ref2.booking,
      isCurrent = _ref2.isCurrent,
      isPast = _ref2.isPast,
      isTour = _ref2.isTour;
  return !isTour && !isCurrent && !isPast && !booking.status.isArchived && !booking.status.isCanceled && !booking.status.isOption && !booking.status.isSearch;
};

var hasSomeUpsellsAlreadyPaid = function hasSomeUpsellsAlreadyPaid(upsells) {
  return (upsells || []).some(function (_ref3) {
    var _ref3$pricingInfo = _ref3.pricingInfo,
        pricingInfo = _ref3$pricingInfo === void 0 ? {} : _ref3$pricingInfo;
    return pricingInfo.isFullyPaid || pricingInfo.isPartiallyPaid;
  });
};

var hasInsuranceEnabled = function hasInsuranceEnabled(b) {
  var _b$information, _b$information$additi, _insurances$0$pricing, _insurances$0$pricing2; // legacy insurance GARNEI should be removed from the API soon, before we have to filter it


  var insurances = (((_b$information = b.information) === null || _b$information === void 0 ? void 0 : (_b$information$additi = _b$information.additionalServices) === null || _b$information$additi === void 0 ? void 0 : _b$information$additi.insurance) || []).filter(function (insurance) {
    var _insurance$pricingInf;

    return (insurance === null || insurance === void 0 ? void 0 : (_insurance$pricingInf = insurance.pricingInfo) === null || _insurance$pricingInf === void 0 ? void 0 : _insurance$pricingInf.id) !== 'GARNEI' || !!(insurance === null || insurance === void 0 ? void 0 : insurance.productInfo);
  });
  return !!insurances.length && !((_insurances$0$pricing = insurances[0].pricingInfo) === null || _insurances$0$pricing === void 0 ? void 0 : _insurances$0$pricing.isFullyPaid) && !((_insurances$0$pricing2 = insurances[0].pricingInfo) === null || _insurances$0$pricing2 === void 0 ? void 0 : _insurances$0$pricing2.isPartiallyPaid);
};

var bookingUtils_hasFreeDepositEnabled = function hasFreeDepositEnabled(b, appContext) {
  var _b$paymentDetails, _b$paymentDetails$due, _b$paymentDetails$due2, _b$paymentDetails2, _b$paymentDetails2$du, _b$information2, _b$information2$stays, _b$information2$stays2;

  return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.banking.enableFreeDeposit') && (((_b$paymentDetails = b.paymentDetails) === null || _b$paymentDetails === void 0 ? void 0 : (_b$paymentDetails$due = _b$paymentDetails.duePayment) === null || _b$paymentDetails$due === void 0 ? void 0 : (_b$paymentDetails$due2 = _b$paymentDetails$due.amount) === null || _b$paymentDetails$due2 === void 0 ? void 0 : _b$paymentDetails$due2.value) || 0) > 0 && (appContext.freeDepositDeadline === 999 ? moment_default()((_b$paymentDetails2 = b.paymentDetails) === null || _b$paymentDetails2 === void 0 ? void 0 : (_b$paymentDetails2$du = _b$paymentDetails2.duePayment) === null || _b$paymentDetails2$du === void 0 ? void 0 : _b$paymentDetails2$du.deadline, apiDate["a" /* API_DATE_FORMAT */]).diff(moment_default()()) > 0 : moment_default()((_b$information2 = b.information) === null || _b$information2 === void 0 ? void 0 : (_b$information2$stays = _b$information2.stays) === null || _b$information2$stays === void 0 ? void 0 : (_b$information2$stays2 = _b$information2$stays[0]) === null || _b$information2$stays2 === void 0 ? void 0 : _b$information2$stays2.departureDate, apiDate["a" /* API_DATE_FORMAT */]).subtract(appContext.freeDepositDeadline, 'day').diff(moment_default()()) > 0);
}; // TEMP : mapper before new GQL Ressource


var bookingUtils_mapBookingEntity = function mapBookingEntity(b, appContext) {
  var _b$information3, _b$information3$vendo, _b$information4, _b$information5, _b$information6, _b$information7, _b$information8, _b$information9, _b$information10, _b$information11, _b$information12, _b$information13, _b$information14, _b$information15, _b$information16, _b$information17, _b$information18, _b$information18$stay, _b$information18$stay2, _b$information$stays$, _b$information19, _b$information19$stay, _b$information20, _b$information20$stay, _b$information20$stay2, _b$information21, _b$information22, _b$information23, _b$information24, _b$paymentDetails3, _b$paymentDetails3$du, _b$paymentDetails3$du2, _b$paymentDetails4, _b$paymentDetails4$du, _b$paymentDetails4$du2, _b$paymentDetails5, _b$paymentDetails5$du, _b$paymentDetails6, _b$paymentDetails6$du, _b$paymentDetails6$du2, _b$paymentDetails7, _b$paymentDetails7$du, _b$paymentDetails7$du2, _b$paymentDetails8, _b$paymentDetails8$al, _b$paymentDetails9, _b$paymentDetails9$al, _b$paymentDetails10, _b$paymentDetails10$a, _b$paymentDetails11, _b$paymentDetails11$a, _b$information25, _b$information26, _b$information27, _b$information28, _b$information29, _b$information30, _b$information31, _b$information32, _b$information33, _b$information34, _b$information34$vend, _b$information35, _b$information35$vend, _b$information36, _b$information36$vend, _b$transports, _b$information37, _b$information37$addi, _b$information37$addi2, _b$information38, _b$information38$pack, _b$information39, _b$information39$addi, _b$information39$addi2, _b$information40, _b$information40$addi, _b$information40$addi2, _b$information41, _b$information41$addi, _b$information41$addi2, _b$information42, _b$information43;

  var isSoldByClubmed = !!((_b$information3 = b.information) === null || _b$information3 === void 0 ? void 0 : (_b$information3$vendo = _b$information3.vendor) === null || _b$information3$vendo === void 0 ? void 0 : _b$information3$vendo.isSoldByClubMed);
  var hasOnlinePaymentEnabled = Boolean((_b$information4 = b.information) === null || _b$information4 === void 0 ? void 0 : _b$information4.shouldProposeOnlinePayment) && Boolean(appContext.canUseOnlinePayment);
  var bookingStatus = {
    current: (_b$information5 = b.information) === null || _b$information5 === void 0 ? void 0 : _b$information5.status,
    isArchived: ((_b$information6 = b.information) === null || _b$information6 === void 0 ? void 0 : _b$information6.status) === bookingStatus_constants["a" /* BOOKING_STATUS_ARCHIVED */],
    isCanceled: ((_b$information7 = b.information) === null || _b$information7 === void 0 ? void 0 : _b$information7.status) === bookingStatus_constants["b" /* BOOKING_STATUS_CANCELED */],
    isExpiredHope: ((_b$information8 = b.information) === null || _b$information8 === void 0 ? void 0 : _b$information8.status) === bookingStatus_constants["c" /* BOOKING_STATUS_EXPIRED_HOPE */],
    isExpiredOption: ((_b$information9 = b.information) === null || _b$information9 === void 0 ? void 0 : _b$information9.status) === bookingStatus_constants["d" /* BOOKING_STATUS_EXPIRED_OPTION */],
    isExpiredQuotation: ((_b$information10 = b.information) === null || _b$information10 === void 0 ? void 0 : _b$information10.status) === bookingStatus_constants["e" /* BOOKING_STATUS_EXPIRED_QUOTATION */],
    isHope: ((_b$information11 = b.information) === null || _b$information11 === void 0 ? void 0 : _b$information11.status) === bookingStatus_constants["f" /* BOOKING_STATUS_HOPE */],
    isOption: ((_b$information12 = b.information) === null || _b$information12 === void 0 ? void 0 : _b$information12.status) === bookingStatus_constants["g" /* BOOKING_STATUS_OPTION */],
    isQuotation: ((_b$information13 = b.information) === null || _b$information13 === void 0 ? void 0 : _b$information13.status) === bookingStatus_constants["h" /* BOOKING_STATUS_QUOTATION */],
    isRequest: ((_b$information14 = b.information) === null || _b$information14 === void 0 ? void 0 : _b$information14.status) === bookingStatus_constants["i" /* BOOKING_STATUS_REQUEST */],
    isSearch: ((_b$information15 = b.information) === null || _b$information15 === void 0 ? void 0 : _b$information15.status) === bookingStatus_constants["j" /* BOOKING_STATUS_SEARCH */],
    isValidated: ((_b$information16 = b.information) === null || _b$information16 === void 0 ? void 0 : _b$information16.status) === bookingStatus_constants["k" /* BOOKING_STATUS_VALIDATED */]
  };
  var isUpsellsEnabled = !bookingStatus.isOption && isSoldByClubmed;
  var booking = {
    attendees: b.attendees || [],
    creationDate: moment_default()((_b$information17 = b.information) === null || _b$information17 === void 0 ? void 0 : _b$information17.creationDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf(),
    dates: {
      endDate: moment_default()((_b$information18 = b.information) === null || _b$information18 === void 0 ? void 0 : (_b$information18$stay = _b$information18.stays) === null || _b$information18$stay === void 0 ? void 0 : (_b$information18$stay2 = _b$information18$stay[((_b$information$stays$ = (_b$information19 = b.information) === null || _b$information19 === void 0 ? void 0 : (_b$information19$stay = _b$information19.stays) === null || _b$information19$stay === void 0 ? void 0 : _b$information19$stay.length) !== null && _b$information$stays$ !== void 0 ? _b$information$stays$ : 0) - 1]) === null || _b$information18$stay2 === void 0 ? void 0 : _b$information18$stay2.returnDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf(),
      startDate: moment_default()((_b$information20 = b.information) === null || _b$information20 === void 0 ? void 0 : (_b$information20$stay = _b$information20.stays) === null || _b$information20$stay === void 0 ? void 0 : (_b$information20$stay2 = _b$information20$stay[0]) === null || _b$information20$stay2 === void 0 ? void 0 : _b$information20$stay2.departureDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf()
    },
    expirationDate: ((_b$information21 = b.information) === null || _b$information21 === void 0 ? void 0 : _b$information21.expirationDate) ? moment_default()((_b$information22 = b.information) === null || _b$information22 === void 0 ? void 0 : _b$information22.expirationDate, 'YYYYMMDD hh:mm:ss Z').valueOf() : null,
    id: (_b$information23 = b.information) === null || _b$information23 === void 0 ? void 0 : _b$information23.bookingId,
    membership: b.loyaltyDetails ? b.loyaltyDetails.map(function (m) {
      return _objectSpread(_objectSpread({}, m), {}, {
        expirationDate: moment_default()(m.expirationDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf()
      });
    }) : null,
    packages: ((_b$information24 = b.information) === null || _b$information24 === void 0 ? void 0 : _b$information24.packagesUpsell) || [],
    payment: {
      due: ((_b$paymentDetails3 = b.paymentDetails) === null || _b$paymentDetails3 === void 0 ? void 0 : (_b$paymentDetails3$du = _b$paymentDetails3.duePayment) === null || _b$paymentDetails3$du === void 0 ? void 0 : (_b$paymentDetails3$du2 = _b$paymentDetails3$du.amount) === null || _b$paymentDetails3$du2 === void 0 ? void 0 : _b$paymentDetails3$du2.value) ? {
        currency: (_b$paymentDetails4 = b.paymentDetails) === null || _b$paymentDetails4 === void 0 ? void 0 : (_b$paymentDetails4$du = _b$paymentDetails4.duePayment) === null || _b$paymentDetails4$du === void 0 ? void 0 : (_b$paymentDetails4$du2 = _b$paymentDetails4$du.amount) === null || _b$paymentDetails4$du2 === void 0 ? void 0 : _b$paymentDetails4$du2.currency,
        deadlineDate: moment_default()((_b$paymentDetails5 = b.paymentDetails) === null || _b$paymentDetails5 === void 0 ? void 0 : (_b$paymentDetails5$du = _b$paymentDetails5.duePayment) === null || _b$paymentDetails5$du === void 0 ? void 0 : _b$paymentDetails5$du.deadline, apiDate["a" /* API_DATE_FORMAT */]).valueOf() || null,
        formattedValue: ((_b$paymentDetails6 = b.paymentDetails) === null || _b$paymentDetails6 === void 0 ? void 0 : (_b$paymentDetails6$du = _b$paymentDetails6.duePayment) === null || _b$paymentDetails6$du === void 0 ? void 0 : (_b$paymentDetails6$du2 = _b$paymentDetails6$du.amount) === null || _b$paymentDetails6$du2 === void 0 ? void 0 : _b$paymentDetails6$du2.formattedValue) || '',
        value: (_b$paymentDetails7 = b.paymentDetails) === null || _b$paymentDetails7 === void 0 ? void 0 : (_b$paymentDetails7$du = _b$paymentDetails7.duePayment) === null || _b$paymentDetails7$du === void 0 ? void 0 : (_b$paymentDetails7$du2 = _b$paymentDetails7$du.amount) === null || _b$paymentDetails7$du2 === void 0 ? void 0 : _b$paymentDetails7$du2.value
      } : null,
      paid: ((_b$paymentDetails8 = b.paymentDetails) === null || _b$paymentDetails8 === void 0 ? void 0 : (_b$paymentDetails8$al = _b$paymentDetails8.alreadyPaidAmount) === null || _b$paymentDetails8$al === void 0 ? void 0 : _b$paymentDetails8$al.value) ? {
        currency: (_b$paymentDetails9 = b.paymentDetails) === null || _b$paymentDetails9 === void 0 ? void 0 : (_b$paymentDetails9$al = _b$paymentDetails9.alreadyPaidAmount) === null || _b$paymentDetails9$al === void 0 ? void 0 : _b$paymentDetails9$al.currency,
        formattedValue: ((_b$paymentDetails10 = b.paymentDetails) === null || _b$paymentDetails10 === void 0 ? void 0 : (_b$paymentDetails10$a = _b$paymentDetails10.alreadyPaidAmount) === null || _b$paymentDetails10$a === void 0 ? void 0 : _b$paymentDetails10$a.formattedValue) || '',
        value: (_b$paymentDetails11 = b.paymentDetails) === null || _b$paymentDetails11 === void 0 ? void 0 : (_b$paymentDetails11$a = _b$paymentDetails11.alreadyPaidAmount) === null || _b$paymentDetails11$a === void 0 ? void 0 : _b$paymentDetails11$a.value
      } : null,
      status: {
        current: (_b$information25 = b.information) === null || _b$information25 === void 0 ? void 0 : _b$information25.paymentStatus,
        isInCredit: (_b$information26 = b.information) === null || _b$information26 === void 0 ? void 0 : _b$information26.isInCredit,
        isPaid: ((_b$information27 = b.information) === null || _b$information27 === void 0 ? void 0 : _b$information27.isPaid) && !((_b$information28 = b.information) === null || _b$information28 === void 0 ? void 0 : _b$information28.isPaymentPending),
        isPending: (_b$information29 = b.information) === null || _b$information29 === void 0 ? void 0 : _b$information29.isPaymentPending,
        isUnpaid: !((_b$information30 = b.information) === null || _b$information30 === void 0 ? void 0 : _b$information30.isPaid) && !((_b$information31 = b.information) === null || _b$information31 === void 0 ? void 0 : _b$information31.isPaymentPending)
      }
    },
    status: bookingStatus,
    upsells: _objectSpread(_objectSpread({}, (_b$information32 = b.information) === null || _b$information32 === void 0 ? void 0 : _b$information32.additionalServices), {}, {
      packages: ((_b$information33 = b.information) === null || _b$information33 === void 0 ? void 0 : _b$information33.packages) || []
    }),
    vendor: {
      current: (_b$information34 = b.information) === null || _b$information34 === void 0 ? void 0 : (_b$information34$vend = _b$information34.vendor) === null || _b$information34$vend === void 0 ? void 0 : _b$information34$vend.soldBy,
      isSoldByClubmed: isSoldByClubmed,
      name: (_b$information35 = b.information) === null || _b$information35 === void 0 ? void 0 : (_b$information35$vend = _b$information35.vendor) === null || _b$information35$vend === void 0 ? void 0 : _b$information35$vend.name,
      phoneNumber: (_b$information36 = b.information) === null || _b$information36 === void 0 ? void 0 : (_b$information36$vend = _b$information36.vendor) === null || _b$information36$vend === void 0 ? void 0 : _b$information36$vend.phoneNumber
    },
    _settings: {
      hasFreeDepositEnabled: bookingUtils_hasFreeDepositEnabled(b, appContext),
      hasMultiTransport: ((_b$transports = b.transports) === null || _b$transports === void 0 ? void 0 : _b$transports.multiTransport) || false,
      hasOnlinePaymentEnabled: hasOnlinePaymentEnabled,
      hasUpsellChildcaresEnabled: isUpsellsEnabled && !!((_b$information37 = b.information) === null || _b$information37 === void 0 ? void 0 : (_b$information37$addi = _b$information37.additionalServices) === null || _b$information37$addi === void 0 ? void 0 : (_b$information37$addi2 = _b$information37$addi.childcares) === null || _b$information37$addi2 === void 0 ? void 0 : _b$information37$addi2.length),
      hasUpsellExcursionsEnabled: isUpsellsEnabled && hasActivitiesType(b, UPSELL_ACTIVITY_TYPE_EXCURSION),
      hasUpsellInsurancesEnabled: isUpsellsEnabled && hasInsuranceEnabled(b),
      hasUpsellLandSportsEnabled: isUpsellsEnabled && hasActivitiesType(b, UPSELL_ACTIVITY_TYPE_LANDSPORT),
      hasUpsellPackagesEnabled: isUpsellsEnabled && !!((_b$information38 = b.information) === null || _b$information38 === void 0 ? void 0 : (_b$information38$pack = _b$information38.packagesUpsell) === null || _b$information38$pack === void 0 ? void 0 : _b$information38$pack.length),
      hasUpsellPickYourRoomEnabled: isUpsellsEnabled,
      hasUpsellRentalsEnabled: isUpsellsEnabled && !!((_b$information39 = b.information) === null || _b$information39 === void 0 ? void 0 : (_b$information39$addi = _b$information39.additionalServices) === null || _b$information39$addi === void 0 ? void 0 : (_b$information39$addi2 = _b$information39$addi.rentals) === null || _b$information39$addi2 === void 0 ? void 0 : _b$information39$addi2.length),
      hasUpsellTransfersEnabled: isUpsellsEnabled && !!((_b$information40 = b.information) === null || _b$information40 === void 0 ? void 0 : (_b$information40$addi = _b$information40.additionalServices) === null || _b$information40$addi === void 0 ? void 0 : (_b$information40$addi2 = _b$information40$addi.transfers) === null || _b$information40$addi2 === void 0 ? void 0 : _b$information40$addi2.length),
      hasUpsellWaterSportsEnabled: isUpsellsEnabled && hasActivitiesType(b, UPSELL_ACTIVITY_TYPE_WATERSPORT),
      hasUpsellWellnessEnabled: isUpsellsEnabled && hasActivitiesType(b, UPSELL_ACTIVITY_TYPE_WELLNESS),
      hasUpsellWinterSportsEnabled: isUpsellsEnabled && hasActivitiesType(b, UPSELL_ACTIVITY_TYPE_WINTERSPORT),
      hasUpsellsWhiteLabelServicesEnabled: isUpsellsEnabled && !!((_b$information41 = b.information) === null || _b$information41 === void 0 ? void 0 : (_b$information41$addi = _b$information41.additionalServices) === null || _b$information41$addi === void 0 ? void 0 : (_b$information41$addi2 = _b$information41$addi.whiteLabelServices) === null || _b$information41$addi2 === void 0 ? void 0 : _b$information41$addi2.length),
      isAllowedToPay: (_b$information42 = b.information) === null || _b$information42 === void 0 ? void 0 : _b$information42.isAllowedToPay
    }
  };
  return _objectSpread(_objectSpread({}, booking), {}, {
    stays: (_b$information43 = b.information) === null || _b$information43 === void 0 ? void 0 : _b$information43.stays.filter(function (st) {
      return st.resort;
    }).map(function (st) {
      var _b$stayFormalities, _formalities$easyArri, _formalities$easyArri2, _formalities$easyArri3, _formalities$easyArri4, _formalities$easyArri5, _formalities$easyArri6, _formalities$easyArri7, _formalities$easyArri8, _formalities$easyArri9, _formalities$creditCa, _formalities$creditCa2, _formalities$creditCa3, _formalities$creditCa4, _formalities$creditCa5, _formalities$creditCa6, _formalities$creditCa7, _formalities$creditCa8, _formalities$creditCa9, _formalities$paymentC, _formalities$paymentC2, _formalities$paymentC3, _formalities$paymentC4, _formalities$paymentC5, _formalities$paymentC6, _formalities$paymentC7, _formalities$paymentC8, _formalities$paymentC9, _formalities$transfer, _formalities$transfer2, _formalities$transfer3, _formalities$transfer4, _formalities$transfer5, _formalities$transfer6, _formalities$transfer7, _formalities$transfer8, _formalities$gmFeedba, _formalities$roomSele, _formalities$roomSele2, _formalities$roomSele3, _formalities$roomSele4, _b$transports2, _b$transports3, _b$information44, _formalities$gmFeedba2, _st$resort, _formalities$roomSele5, _st$resort2, _st$resort3, _formalities$transfer9;

      var formalities = (_b$stayFormalities = b.stayFormalities) === null || _b$stayFormalities === void 0 ? void 0 : _b$stayFormalities.find(function (sf) {
        return sf.stayId === st.id;
      });
      var endDate = moment_default()(st.returnDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf();
      var startDate = moment_default()(st.departureDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf();
      var now = new Date();
      var isPast = moment_default()(endDate).add(1, 'days') // API st.returnDate is at 00:00:00 time
      .valueOf() < now.valueOf();
      var isCurrent = startDate < now.valueOf() && !isPast;
      var productUri = new URI_default.a(st.resort.href || '');
      return {
        accommodation: st.accommodations ? Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
          accommodations: st.accommodations,
          accommodationsCount: st.accommodations.length,
          attendeesWithDistributionData: [],
          proposal: null,
          resort: st.resort,
          remainingStock: accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] + 1,
          streetViews: []
        }) : {},
        app: {
          url: st.appUrl
        },
        booking: {
          expirationDate: booking.expirationDate,
          id: booking.id,
          dates: booking.dates,
          packages: booking.packages,
          payment: booking.payment,
          status: booking.status,
          upsells: booking.upsells,
          vendor: booking.vendor,
          _settings: booking._settings
        },
        dates: {
          duration: st.duration,
          endDate: endDate,
          isCurrent: isCurrent,
          isPast: isPast,
          startDate: startDate
        },
        features: {
          easyArrival: {
            status: {
              current: formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri = formalities.easyArrival) === null || _formalities$easyArri === void 0 ? void 0 : _formalities$easyArri.status,
              isActivated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri2 = formalities.easyArrival) === null || _formalities$easyArri2 === void 0 ? void 0 : _formalities$easyArri2.status) === constants["a" /* API_ACTIVATED */],
              isAvailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri3 = formalities.easyArrival) === null || _formalities$easyArri3 === void 0 ? void 0 : _formalities$easyArri3.status) === constants["b" /* API_AVAILABLE */],
              isDone: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri4 = formalities.easyArrival) === null || _formalities$easyArri4 === void 0 ? void 0 : _formalities$easyArri4.status) === constants["c" /* API_DONE */],
              isNotYet: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri5 = formalities.easyArrival) === null || _formalities$easyArri5 === void 0 ? void 0 : _formalities$easyArri5.status) === constants["d" /* API_NOTYET */],
              isUnavailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri6 = formalities.easyArrival) === null || _formalities$easyArri6 === void 0 ? void 0 : _formalities$easyArri6.status) === constants["f" /* API_UNAVAILABLE */],
              isUneditable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri7 = formalities.easyArrival) === null || _formalities$easyArri7 === void 0 ? void 0 : _formalities$easyArri7.status) === constants["g" /* API_UNEDITABLE */],
              isValidated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri8 = formalities.easyArrival) === null || _formalities$easyArri8 === void 0 ? void 0 : _formalities$easyArri8.status) === constants["i" /* API_VALIDATED */]
            },
            url: formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri9 = formalities.easyArrival) === null || _formalities$easyArri9 === void 0 ? void 0 : _formalities$easyArri9.href
          },
          easyCheckInOut: {
            easyCheckIn: {
              isActivated: formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa = formalities.creditCardCheckIn) === null || _formalities$creditCa === void 0 ? void 0 : _formalities$creditCa.activated,
              status: {
                current: formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa2 = formalities.creditCardCheckIn) === null || _formalities$creditCa2 === void 0 ? void 0 : _formalities$creditCa2.status,
                isActivated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa3 = formalities.creditCardCheckIn) === null || _formalities$creditCa3 === void 0 ? void 0 : _formalities$creditCa3.status) === constants["a" /* API_ACTIVATED */],
                isAvailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa4 = formalities.creditCardCheckIn) === null || _formalities$creditCa4 === void 0 ? void 0 : _formalities$creditCa4.status) === constants["b" /* API_AVAILABLE */],
                isDone: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa5 = formalities.creditCardCheckIn) === null || _formalities$creditCa5 === void 0 ? void 0 : _formalities$creditCa5.status) === constants["c" /* API_DONE */],
                isNotYet: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa6 = formalities.creditCardCheckIn) === null || _formalities$creditCa6 === void 0 ? void 0 : _formalities$creditCa6.status) === constants["d" /* API_NOTYET */],
                isUnavailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa7 = formalities.creditCardCheckIn) === null || _formalities$creditCa7 === void 0 ? void 0 : _formalities$creditCa7.status) === constants["f" /* API_UNAVAILABLE */],
                isUneditable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa8 = formalities.creditCardCheckIn) === null || _formalities$creditCa8 === void 0 ? void 0 : _formalities$creditCa8.status) === constants["g" /* API_UNEDITABLE */],
                isValidated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa9 = formalities.creditCardCheckIn) === null || _formalities$creditCa9 === void 0 ? void 0 : _formalities$creditCa9.status) === constants["i" /* API_VALIDATED */]
              }
            },
            easyCheckOut: {
              isActivated: formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC = formalities.paymentCheckOut) === null || _formalities$paymentC === void 0 ? void 0 : _formalities$paymentC.activated,
              status: {
                current: formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC2 = formalities.paymentCheckOut) === null || _formalities$paymentC2 === void 0 ? void 0 : _formalities$paymentC2.status,
                isActivated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC3 = formalities.paymentCheckOut) === null || _formalities$paymentC3 === void 0 ? void 0 : _formalities$paymentC3.status) === constants["a" /* API_ACTIVATED */],
                isAvailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC4 = formalities.paymentCheckOut) === null || _formalities$paymentC4 === void 0 ? void 0 : _formalities$paymentC4.status) === constants["b" /* API_AVAILABLE */],
                isDone: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC5 = formalities.paymentCheckOut) === null || _formalities$paymentC5 === void 0 ? void 0 : _formalities$paymentC5.status) === constants["c" /* API_DONE */],
                isNotYet: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC6 = formalities.paymentCheckOut) === null || _formalities$paymentC6 === void 0 ? void 0 : _formalities$paymentC6.status) === constants["d" /* API_NOTYET */],
                isUnavailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC7 = formalities.paymentCheckOut) === null || _formalities$paymentC7 === void 0 ? void 0 : _formalities$paymentC7.status) === constants["f" /* API_UNAVAILABLE */],
                isUneditable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC8 = formalities.paymentCheckOut) === null || _formalities$paymentC8 === void 0 ? void 0 : _formalities$paymentC8.status) === constants["g" /* API_UNEDITABLE */],
                isValidated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC9 = formalities.paymentCheckOut) === null || _formalities$paymentC9 === void 0 ? void 0 : _formalities$paymentC9.status) === constants["i" /* API_VALIDATED */]
              }
            }
          },
          easyTransfer: {
            status: {
              current: formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer = formalities.transfer) === null || _formalities$transfer === void 0 ? void 0 : _formalities$transfer.traveling_information_status,
              isActivated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer2 = formalities.transfer) === null || _formalities$transfer2 === void 0 ? void 0 : _formalities$transfer2.traveling_information_status) === constants["a" /* API_ACTIVATED */],
              isAvailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer3 = formalities.transfer) === null || _formalities$transfer3 === void 0 ? void 0 : _formalities$transfer3.traveling_information_status) === constants["b" /* API_AVAILABLE */],
              isDone: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer4 = formalities.transfer) === null || _formalities$transfer4 === void 0 ? void 0 : _formalities$transfer4.traveling_information_status) === constants["c" /* API_DONE */],
              isNotYet: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer5 = formalities.transfer) === null || _formalities$transfer5 === void 0 ? void 0 : _formalities$transfer5.traveling_information_status) === constants["d" /* API_NOTYET */],
              isUnavailable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer6 = formalities.transfer) === null || _formalities$transfer6 === void 0 ? void 0 : _formalities$transfer6.traveling_information_status) === constants["f" /* API_UNAVAILABLE */],
              isUneditable: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer7 = formalities.transfer) === null || _formalities$transfer7 === void 0 ? void 0 : _formalities$transfer7.traveling_information_status) === constants["g" /* API_UNEDITABLE */],
              isValidated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer8 = formalities.transfer) === null || _formalities$transfer8 === void 0 ? void 0 : _formalities$transfer8.traveling_information_status) === constants["i" /* API_VALIDATED */]
            }
          },
          feedback: {
            url: formalities === null || formalities === void 0 ? void 0 : (_formalities$gmFeedba = formalities.gmFeedback) === null || _formalities$gmFeedba === void 0 ? void 0 : _formalities$gmFeedba.href
          },
          pickYourRoom: {
            status: {
              current: formalities === null || formalities === void 0 ? void 0 : (_formalities$roomSele = formalities.roomSelection) === null || _formalities$roomSele === void 0 ? void 0 : _formalities$roomSele.status,
              isActivated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$roomSele2 = formalities.roomSelection) === null || _formalities$roomSele2 === void 0 ? void 0 : _formalities$roomSele2.status) === constants["a" /* API_ACTIVATED */],
              isResortOnly: (formalities === null || formalities === void 0 ? void 0 : (_formalities$roomSele3 = formalities.roomSelection) === null || _formalities$roomSele3 === void 0 ? void 0 : _formalities$roomSele3.status) === constants["e" /* API_RESORT_ONLY */],
              isValidated: (formalities === null || formalities === void 0 ? void 0 : (_formalities$roomSele4 = formalities.roomSelection) === null || _formalities$roomSele4 === void 0 ? void 0 : _formalities$roomSele4.status) === constants["i" /* API_VALIDATED */]
            }
          }
        },
        id: st.id,
        participants: {
          adults: st.adults,
          attendees: booking.attendees.filter(function (a) {
            return (st.attendeesIds || []).includes(a.id);
          }).map(function (a) {
            return _objectSpread(_objectSpread({}, a), {}, {
              birthday: moment_default()(a.birthday, apiDate["a" /* API_DATE_FORMAT */]).valueOf(),
              firstname: upperFirst_default()(a.firstname.toLowerCase()),
              isKid: dist["attendees"].isKid(a),
              lastname: upperFirst_default()(a.lastname.toLowerCase())
            });
          }),
          children: st.children,
          total: st.adults + st.children
        },
        product: _objectSpread(_objectSpread({}, st.resort), {}, {
          href: dist["url"].normalizeUrl(productUri.toString())
        }),
        staff: st.goStaff || [],
        transport: st.departureCity ? {
          fromCity: upperFirst_default()(st.departureCity.toLowerCase()),
          inbounds: (((_b$transports2 = b.transports) === null || _b$transports2 === void 0 ? void 0 : _b$transports2.inbounds) || []).filter(function (bound) {
            var _bound$travelSections;

            return (bound === null || bound === void 0 ? void 0 : bound.stayId) === st.id && (bound === null || bound === void 0 ? void 0 : (_bound$travelSections = bound.travelSections) === null || _bound$travelSections === void 0 ? void 0 : _bound$travelSections.length);
          }),
          outbounds: (((_b$transports3 = b.transports) === null || _b$transports3 === void 0 ? void 0 : _b$transports3.outbounds) || []).filter(function (bound) {
            var _bound$travelSections2;

            return (bound === null || bound === void 0 ? void 0 : bound.stayId) === st.id && (bound === null || bound === void 0 ? void 0 : (_bound$travelSections2 = bound.travelSections) === null || _bound$travelSections2 === void 0 ? void 0 : _bound$travelSections2.length);
          }),
          toCity: upperFirst_default()(st.arrivalCity.toLowerCase()),
          type: st.transportType
        } : null,
        _legacy: _objectSpread(_objectSpread({}, st), {}, {
          vendor: (_b$information44 = b.information) === null || _b$information44 === void 0 ? void 0 : _b$information44.vendor
        }),
        _settings: {
          hasEasyArrivalEnabled: bookingUtils_isEasyArrivalEnabled(formalities),
          hasEasyCheckInOutEnabled: bookingUtils_isEasyCheckInOutEnabled(formalities),
          hasEasyTransferEnabled: bookingUtils_isEasyTransferEnabled(formalities, st.resort),
          hasFeedbackEnabled: (formalities === null || formalities === void 0 ? void 0 : (_formalities$gmFeedba2 = formalities.gmFeedback) === null || _formalities$gmFeedba2 === void 0 ? void 0 : _formalities$gmFeedba2.status) === constants["b" /* API_AVAILABLE */],
          hasTransportEnabled: !st.resort.isJoyview && isSoldByClubmed,
          hasUpsellsEnabled: hasUpsellsEnabled({
            booking: booking,
            isCurrent: isCurrent,
            isPast: isPast,
            isTour: st.resort.isTour
          }),
          hasUpsellESFEnabled: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('memberSpace.enableEsfWidget') && !!((_st$resort = st.resort) === null || _st$resort === void 0 ? void 0 : _st$resort.esfResortId),
          hasUpsellPickYourRoomEnabled: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.allow') && [constants["a" /* API_ACTIVATED */], constants["b" /* API_AVAILABLE */], constants["i" /* API_VALIDATED */], Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.resortOnlyRequestForm') ? constants["e" /* API_RESORT_ONLY */] : null].filter(Boolean).includes(formalities === null || formalities === void 0 ? void 0 : (_formalities$roomSele5 = formalities.roomSelection) === null || _formalities$roomSele5 === void 0 ? void 0 : _formalities$roomSele5.status),
          hasUpsellRentalsEnabled: booking._settings.hasUpsellRentalsEnabled && (((_st$resort2 = st.resort) === null || _st$resort2 === void 0 ? void 0 : _st$resort2.category) === WINTER_MOUNTAIN_RESORT && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('memberSpace.allowMultipleScheduleRental') || !booking_constants["u" /* MULTI_SCHEDULE_RESORTS */].includes((_st$resort3 = st.resort) === null || _st$resort3 === void 0 ? void 0 : _st$resort3.id)),
          hasUpsellTransfersEnabled: (formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer9 = formalities.transfer) === null || _formalities$transfer9 === void 0 ? void 0 : _formalities$transfer9.service_status) === constants["h" /* API_UPSELL_AVAILABLE */],
          hasWhiteLabelServicesUpsellsEnabled: booking._settings.hasUpsellsWhiteLabelServicesEnabled
        }
      };
    })
  });
};
var bookingUtils_isEasyArrivalEnabled = function isEasyArrivalEnabled(formalities) {
  var _formalities$easyArri10;

  return [constants["a" /* API_ACTIVATED */], constants["b" /* API_AVAILABLE */], constants["c" /* API_DONE */], constants["g" /* API_UNEDITABLE */], constants["i" /* API_VALIDATED */]].includes(formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri10 = formalities.easyArrival) === null || _formalities$easyArri10 === void 0 ? void 0 : _formalities$easyArri10.status);
};
var bookingUtils_isEasyCheckInOutEnabled = function isEasyCheckInOutEnabled(formalities) {
  var _formalities$creditCa10, _formalities$paymentC10;

  return [formalities === null || formalities === void 0 ? void 0 : (_formalities$creditCa10 = formalities.creditCardCheckIn) === null || _formalities$creditCa10 === void 0 ? void 0 : _formalities$creditCa10.status, formalities === null || formalities === void 0 ? void 0 : (_formalities$paymentC10 = formalities.paymentCheckOut) === null || _formalities$paymentC10 === void 0 ? void 0 : _formalities$paymentC10.status].some(function (status) {
    return [constants["a" /* API_ACTIVATED */], constants["b" /* API_AVAILABLE */], constants["g" /* API_UNEDITABLE */], constants["i" /* API_VALIDATED */]].includes(status);
  });
};
var bookingUtils_isEasyTransferEnabled = function isEasyTransferEnabled(formalities, resort) {
  var _formalities$transfer10;

  return !resort.isJoyview && [constants["a" /* API_ACTIVATED */], constants["b" /* API_AVAILABLE */], constants["i" /* API_VALIDATED */]].includes(formalities === null || formalities === void 0 ? void 0 : (_formalities$transfer10 = formalities.transfer) === null || _formalities$transfer10 === void 0 ? void 0 : _formalities$transfer10.service_status);
};
var hasActivitiesUpsellsEnabled = function hasActivitiesUpsellsEnabled(_ref4) {
  var booking = _ref4.booking;
  return booking._settings.hasUpsellExcursionsEnabled || booking._settings.hasUpsellLandSportsEnabled || booking._settings.hasUpsellWaterSportsEnabled || booking._settings.hasUpsellWellnessEnabled || booking._settings.hasUpsellWinterSportsEnabled;
};
var hasServicesUpsellsEnabled = function hasServicesUpsellsEnabled(_ref5) {
  var booking = _ref5.booking,
      _settings = _ref5._settings;
  return booking._settings.hasUpsellInsurancesEnabled || booking._settings.hasUpsellTransfersEnabled && _settings.hasUpsellTransfersEnabled || booking._settings.hasUpsellChildcaresEnabled || booking._settings.hasUpsellRentalsEnabled && _settings.hasUpsellRentalsEnabled || booking._settings.hasUpsellPackagesEnabled || _settings.hasUpsellESFEnabled || booking._settings.hasUpsellPickYourRoomEnabled && _settings.hasUpsellPickYourRoomEnabled;
};
var hasWhiteLabelServicesUpsellsEnabled = function hasWhiteLabelServicesUpsellsEnabled(_ref6) {
  var booking = _ref6.booking;
  return booking._settings.hasUpsellsWhiteLabelServicesEnabled;
};
var bookingUtils_getCGVFromLegalInfos = function getCGVFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["b" /* LEGAL_INFO_CGV_ID */];
  }) || {
    label: ''
  };
};
var bookingUtils_getHealthRegulationsFromLegalInfos = function getHealthRegulationsFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["a" /* HEALTH_REGULATION */];
  }) || null;
};
var bookingUtils_tAlt = function tAlt(_ref7) {
  var resortKeyPath = _ref7.resortKeyPath,
      cruiseKeyPath = _ref7.cruiseKeyPath,
      resort = _ref7.resort,
      variables = _ref7.variables;
  return Object(i18n["h" /* t */])(resort.type === PRODUCT_TYPES.CRUISE ? cruiseKeyPath : resortKeyPath, variables);
};
var bookingUtils_getActivityTypeName = function getActivityTypeName(type) {
  return Object(string_util["b" /* snakeToCamel */])(type.toLowerCase().replace('rental', 'ski'));
};
var bookingUtils_getBookingEngineUrl = function getBookingEngineUrl(appContext, stay, currentUri) {
  var params = {
    reference: stay.booking.id,
    resortId: stay.product.id,
    fromSearches: 'true'
  };
  return buildUrlFromContextNumber(params, appContext, currentUri);
};
var isOptionAboutToExpire = function isOptionAboutToExpire(booking) {
  return booking.expirationDate ? booking.expirationDate - 3600000 * 1
  /* 1h */
  <= new Date().valueOf() : false;
};
var bookingUtils_getStaffChief = function getStaffChief() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return staff.find(function (_ref8) {
    var _ref8$categories = _ref8.categories,
        categories = _ref8$categories === void 0 ? [] : _ref8$categories;
    return categories.some(function (_ref9) {
      var code = _ref9.code,
          label = _ref9.label;
      return [code, label].includes(booking_constants["y" /* STAFF_CHIEF_CODE */]);
    });
  }) || staff[0];
};
var bookingUtils_getStaffCategories = function getStaffCategories() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (// $FlowFixMe
    sortBy_default()(uniqBy_default()(staff.reduce(function (acc, s) {
      return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(s.categories));
    }, []).map(function (_ref10) {
      var code = _ref10.code,
          label = _ref10.label;
      return {
        label: label,
        value: code
      };
    }), 'value'), ['label'])
  );
};

/***/ }),

/***/ "blgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_STATUS_ARCHIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_STATUS_CANCELED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_STATUS_EXPIRED_HOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_STATUS_EXPIRED_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_STATUS_EXPIRED_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_STATUS_HOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BOOKING_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BOOKING_STATUS_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BOOKING_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BOOKING_STATUS_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BOOKING_STATUS_VALIDATED; });
var BOOKING_STATUS_ARCHIVED = 'ARCHIVED';
var BOOKING_STATUS_CANCELED = 'CANCELED';
var BOOKING_STATUS_EXPIRED_HOPE = 'EXPIRED_HOPE';
var BOOKING_STATUS_EXPIRED_OPTION = 'EXPIRED_OPTION';
var BOOKING_STATUS_EXPIRED_QUOTATION = 'EXPIRED_QUOTATION';
var BOOKING_STATUS_HOPE = 'HOPE';
var BOOKING_STATUS_OPTION = 'OPTION';
var BOOKING_STATUS_QUOTATION = 'QUOTATION';
var BOOKING_STATUS_REQUEST = 'REQUEST';
var BOOKING_STATUS_SEARCH = 'SEARCH';
var BOOKING_STATUS_VALIDATED = 'VALIDATED';


/***/ }),

/***/ "cb6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccommodationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aggregateIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBabyBedIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCapacityIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSurfaceIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOutsideFacilitiesIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getViewIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNbBabies; });
/* unused harmony export hasLowStock */
/* unused harmony export getAccommodationCategoryComfortIndex */
/* unused harmony export getBestAccommodationCategory */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2dTi");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("cFQB");
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lozs");
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("3dHC");
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("lZ21");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("aWOT");
/* harmony import */ var _accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("OsvN");


























var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var ICONS_ROOM_TYPE = {
  CONNECTING_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS_3,
  SEPARATE_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS,
  SINGLE_ROOM: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SINGLE_ROOM
};

function getCapacityIconItem(capacity) {
  var label = Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.packageContent.numberPeople');

  if (!capacity || !label) {
    return null;
  }

  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].PEOPLE,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.packageContent.capacityOfPeople'), Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(label).format({
      count: capacity
    })]
  };
}

function getSurfaceIconItem(roomType, resort, surface) {
  return {
    icon: ICONS_ROOM_TYPE[roomType] || null,
    labels: [Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__[/* tAlt */ "p"])({
      resortKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_23__[/* CORRESPONDANCE_ROOM_TYPE */ "c"][roomType]),
      cruiseKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_23__[/* CORRESPONDENCE_CABIN_TYPE */ "d"][roomType]),
      resort: resort
    }), surface || roomType && ' ' || '']
  };
}

function getNbBabies(occupancies) {
  if (!occupancies) {
    return 0;
  }

  return occupancies.reduce(function () {
    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var occupancy = arguments.length > 1 ? arguments[1] : undefined;
    return acc + occupancy.baby_count;
  }, 0);
}

function getBabyBedIconItem(babyCount) {
  if (babyCount <= 0) {
    return null;
  }

  var label = babyCount > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincludedPlural') : Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincluded');
  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].baby_bed,
    labels: [label]
  };
}

function getOutsideFacilitiesIconItem(outsideFacilities) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities, '[0].label') ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities[0], 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [outsideFacilities[0].label]
  } : null;
}

function getViewIconItem(view) {
  return view ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(view, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [view.label]
  } : null;
}

function aggregateIconList(strengths, surface, capacity, outsideFacility, view, babyBed) {
  var isComparator = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isInMoreRoomLayer = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var proposal = arguments.length > 8 ? arguments[8] : undefined;
  var currentComfortAlternatives = arguments.length > 9 ? arguments[9] : undefined; // add a "strengths slot" for each missing item

  var maxStrengths = 3 - [view, capacity, babyBed, outsideFacility].filter(function (item) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(item, 'labels.0');
  }).length;
  var strengthsItems = (strengths || []).slice(0, Math.max(maxStrengths, 0)).map(function (strength) {
    return {
      icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
      labels: [lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'label') || '']
    };
  });
  var chooseYourViewItem = {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.roomFinder.viewFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.common.add')
  };
  var chooseYourFacilityItem = {
    icon: 'terrace',
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.accommodation.roomFinder.facilitiesFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.common.add')
  };
  var hasViewAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_25__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    proposal: proposal
  });
  var hasOFAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_25__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: 'terrace',
    proposal: proposal
  });
  var viewWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasViewAlternative ? view || chooseYourViewItem : view;
  var outsideFacilityWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasOFAlternative ? outsideFacility || chooseYourFacilityItem : outsideFacility;
  return lodash_compact__WEBPACK_IMPORTED_MODULE_17___default()([surface, capacity, outsideFacilityWithDefaultIfNone, babyBed].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(strengthsItems), [viewWithDefaultIfNone])).filter(function (_ref) {
    var _ref$labels = _ref.labels,
        labels = _ref$labels === void 0 ? [] : _ref$labels;
    return labels.length && labels[0];
  });
}

function hasLowStock(threshold, stock) {
  return stock <= threshold;
}

function getAccommodationCategoryComfortIndex(category) {
  return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_23__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(category.id);
}

function getBestAccommodationCategory(categories) {
  if (categories.length === 1) {
    return categories[0];
  }

  return lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default()(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default()(getAccommodationCategoryComfortIndex), lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default.a)(categories);
}

var getAccommodationRoomsProps = function getAccommodationRoomsProps(_ref2) {
  var _ref2$accommodations = _ref2.accommodations,
      accommodations = _ref2$accommodations === void 0 ? [] : _ref2$accommodations,
      accommodationsCount = _ref2.accommodationsCount,
      attendeesWithDistributionData = _ref2.attendeesWithDistributionData,
      _ref2$proposal = _ref2.proposal,
      proposal = _ref2$proposal === void 0 ? {} : _ref2$proposal,
      remainingStock = _ref2.remainingStock,
      resort = _ref2.resort,
      streetViews = _ref2.streetViews,
      _ref2$isComparator = _ref2.isComparator,
      isComparator = _ref2$isComparator === void 0 ? false : _ref2$isComparator,
      _ref2$isInMoreRoomLay = _ref2.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref2$isInMoreRoomLay === void 0 ? false : _ref2$isInMoreRoomLay,
      alternatives = _ref2.alternatives;

  var sortedAccommodations = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(accommodations).sort(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* compareAccommodationsByComfort */ "b"]).filter(Boolean);

  var sortedAttendees = {
    adults: attendeesWithDistributionData.filter(function (_ref3) {
      var type = _ref3.type;
      return type === ATTENDEE_CATEGORIES.ADULT;
    }),
    babies: attendeesWithDistributionData.filter(function (_ref4) {
      var type = _ref4.type;
      return type === ATTENDEE_CATEGORIES.BABY;
    }),
    children: attendeesWithDistributionData.filter(function (_ref5) {
      var type = _ref5.type;
      return type === ATTENDEE_CATEGORIES.CHILD;
    })
  };
  return sortedAccommodations.map(function (a) {
    var _a$attendeesDistribut, _proposal$attendees, _proposal$attendees$a, _proposal$attendees2, _proposal$attendees2$, _a$media, _proposal$attendees3, _proposal$attendees3$;

    var attendeesIds = (((_a$attendeesDistribut = a.attendeesDistribution) === null || _a$attendeesDistribut === void 0 ? void 0 : _a$attendeesDistribut.attendees) || []).map(function (at) {
      return at.id;
    });
    var matchingStreetViewElement = (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) ? streetViews.find(function (_ref6) {
      var accommodationCategoryId = _ref6.accommodationCategoryId;
      return accommodationCategoryId === a.categoryId;
    }) : {};
    var isPremium = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isPremiumAccommodation */ "C"])(a);
    var isExclusiveCollection = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isExclusiveCollectionRoom */ "y"])(a, resort);

    var getSplitServices = function getSplitServices(services) {
      var servicesToSplit = services.slice(0);

      if (isExclusiveCollection) {
        var mainServices = servicesToSplit.splice(0, 6);
        return [servicesToSplit, mainServices];
      }

      return [servicesToSplit];
    };

    var services = a.services && getSplitServices(a.services);

    var getServicesIconsList = function getServicesIconsList() {
      var _services$; // $FlowFixMe


      if ((services === null || services === void 0 ? void 0 : (_services$ = services[1]) === null || _services$ === void 0 ? void 0 : _services$.length) > 0) {
        // $FlowFixMe
        return services[1].map(function (_ref7) {
          var id = _ref7.id,
              label = _ref7.label;
          return {
            icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][id] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
            labels: [label]
          };
        });
      }

      return null;
    };

    var currentComfortAlternatives = alternatives === null || alternatives === void 0 ? void 0 : alternatives.find(function (_ref8) {
      var categoryId = _ref8.categoryId;
      return categoryId === a.categoryId;
    });
    return {
      bathroomEquipments: a.bathroomEquipments,
      categoryId: a.categoryId,
      description: a.description,
      distribution: (sortedAccommodations.length > 1 || a.quantity > 1) && !!attendeesIds.length ? {
        adults: sortedAttendees.adults.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        babies: sortedAttendees.babies.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        children: sortedAttendees.children.filter(function (at) {
          return attendeesIds.includes(at.id);
        })
      } : null,
      equipments: a.equipments,
      hasArrangement: accommodations.length !== (accommodationsCount ? accommodationsCount : proposal === null || proposal === void 0 ? void 0 : proposal.accommodationsCount),
      hasDistribution: sortedAccommodations.length > 1 && !!attendeesIds.length,
      hasSharedRoom: ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$a = _proposal$attendees.adults) === null || _proposal$attendees$a === void 0 ? void 0 : _proposal$attendees$a.length) || 0) + ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees2 = proposal.attendees) === null || _proposal$attendees2 === void 0 ? void 0 : (_proposal$attendees2$ = _proposal$attendees2.children) === null || _proposal$attendees2$ === void 0 ? void 0 : _proposal$attendees2$.length) || 0) === 1 && resort.id === 'KEMC',
      id: a.id,
      images: (((_a$media = a.media) === null || _a$media === void 0 ? void 0 : _a$media.photos) || []).map(function (m) {
        return {
          src: m.url
        };
      }),
      floorPlans: a.floorPlans,
      name: a.label,
      infosList: aggregateIconList(a.strengths, getSurfaceIconItem(a.roomType, resort, a.surface), undefined, // $FlowFixMe
      getOutsideFacilitiesIconItem(a.outsideFacilities), getViewIconItem(a.view), getBabyBedIconItem(getNbBabies(a.occupancies)), isComparator, isInMoreRoomLayer, proposal, currentComfortAlternatives),
      servicesIconsList: getServicesIconsList(),
      isBestFamilyDeal: (a.familyRoom || a.connectingRoom) && ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees3 = proposal.attendees) === null || _proposal$attendees3 === void 0 ? void 0 : (_proposal$attendees3$ = _proposal$attendees3.children) === null || _proposal$attendees3$ === void 0 ? void 0 : _proposal$attendees3$.length) || 0) > 0,
      isCabin: resort.isCruise,
      isPremium: isPremium,
      isExclusiveCollectionRoom: isExclusiveCollection,
      isExclusiveCollectionSpace: Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isExclusiveCollectionSpace */ "z"])(a, resort),
      outsideFacilities: a.outsideFacilities,
      quantity: a.quantity,
      // $FlowFixMe
      services: services === null || services === void 0 ? void 0 : services[0],
      stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0,
      streetView: matchingStreetViewElement === null || matchingStreetViewElement === void 0 ? void 0 : matchingStreetViewElement.streetView
    };
  });
};

var getAccommodationProps = function getAccommodationProps(_ref9) {
  var _proposal$price;

  var _ref9$accommodations = _ref9.accommodations,
      accommodations = _ref9$accommodations === void 0 ? [] : _ref9$accommodations,
      accommodationsCount = _ref9.accommodationsCount,
      attendeesWithDistributionData = _ref9.attendeesWithDistributionData,
      _ref9$proposal = _ref9.proposal,
      proposal = _ref9$proposal === void 0 ? {} : _ref9$proposal,
      resort = _ref9.resort,
      remainingStock = _ref9.remainingStock,
      streetViews = _ref9.streetViews,
      _ref9$isComparator = _ref9.isComparator,
      isComparator = _ref9$isComparator === void 0 ? false : _ref9$isComparator,
      _ref9$isInMoreRoomLay = _ref9.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref9$isInMoreRoomLay === void 0 ? false : _ref9$isInMoreRoomLay,
      alternatives = _ref9.alternatives;
  var rooms = getAccommodationRoomsProps({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    attendeesWithDistributionData: attendeesWithDistributionData,
    proposal: proposal,
    remainingStock: remainingStock,
    resort: resort,
    streetViews: streetViews,
    isComparator: isComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    alternatives: alternatives
  });
  return {
    hasFlexRates: proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.hasFlexRates,
    isCabin: resort.isCruise,
    proposal: proposal,
    rooms: rooms,
    stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0
  };
};


/***/ }),

/***/ "dm5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButtonWithIcon; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("/HC4");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;



var RadioButtonWithIcon = function RadioButtonWithIcon(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      value = _ref.value,
      name = _ref.name,
      priceDifference = _ref.priceDifference,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'RadioButtonWithIcon' : _ref$testId;
  return __jsx("div", {
    className: "h-full",
    "data-testId": testId
  }, __jsx("div", {
    className: "border-1 border-light-gray h-full flex flex-col leading-normal overflow-hidden p-15 rounded-tiny text-blue text-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: "mb-10 m-auto",
    name: icon,
    width: "2em",
    dataTestid: "RadioButtonWithIcon-icon"
  }), __jsx("div", {
    className: "leading-tight w-full font-bold text-12"
  }, title), __jsx("div", {
    className: "leading-tight w-full text-10 text-gray-darker"
  }, description), __jsx("div", {
    className: "m-auto"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    className: "ml-10",
    name: name,
    value: value,
    type: "radio"
  })), !!priceDifference && __jsx("div", {
    className: "leading-tight w-full font-bold text-12"
  }, priceDifference)));
};

/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "pWxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
/* unused harmony export LOCALES_TO_DISPLAY_DIDOMI */
var LOCALES = {
  EN_CN: 'en-CN',
  PT_BR: 'pt-BR',
  ZH_CN: 'zh-CN',
  FR_FR: 'fr-FR',
  RU_RU: 'ru-RU',
  UK_UA: 'uk-UA'
};
var LOCALES_TO_DISPLAY_DIDOMI = [LOCALES.FR_FR];


/***/ }),

/***/ "sRHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "sjzV":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW");

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ }),

/***/ "wNDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ NotFoundError; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BadRequest; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ClientSideError; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ProposalNotFound; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ errors_ApiException; });

// UNUSED EXPORTS: CmsConfigError, RequestFailed, GraphqlError, OfferNotFound, ZoneNotFound, LandingNotFound, ResortNotFound, PriceNotFound, PageNotFound

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("XcBm");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct;
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }

  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };

  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/errors/errors.js












function _createSuper(Derived) {
  var hasNativeReflectConstruct = errors_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function errors_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


var NotFoundError = error_js_default.a.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn'
});
var BadRequest = error_js_default.a.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error'
});
var CmsConfigError = error_js_default.a.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error'
});
var RequestFailed = error_js_default.a.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error'
});
var GraphqlError = error_js_default.a.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error'
});
var ClientSideError = error_js_default.a.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error'
});
var OfferNotFound = error_js_default.a.create({
  name: 'OfferNotFound'
}, NotFoundError);
var ZoneNotFound = error_js_default.a.create({
  name: 'ZoneNotFound'
}, NotFoundError);
var LandingNotFound = error_js_default.a.create({
  name: 'LandingNotFound'
}, NotFoundError);
var ResortNotFound = error_js_default.a.create({
  name: 'ResortNotFound'
}, NotFoundError);
var PriceNotFound = error_js_default.a.create({
  name: 'PriceNotFound'
}, NotFoundError);
var ProposalNotFound = error_js_default.a.create({
  name: 'ProposalNotFound'
}, NotFoundError);
var PageNotFound = error_js_default.a.create({
  name: 'PageNotFound'
}, NotFoundError);
var errors_ApiException = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ApiException, _Error);

  var _super = _createSuper(ApiException);

  function ApiException(errors) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ApiException);

    _this = _super.call.apply(_super, [this].concat(Object(toConsumableArray["a" /* default */])(errors)));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "apiErrors", void 0);

    _this.name = 'ApiException';
    _this.apiErrors = errors;
    return _this;
  }

  return ApiException;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BOAT */
/* unused harmony export PLANE */
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSPORT_CLASS_TO_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SNCF_ID; });
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatConnectionLabel; });
/* unused harmony export getStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isTransportPlaneTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCancellationPolicyDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getNDCCancelationPolicyDescription; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Jhhs");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ZHrn");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("XpIN");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");





















var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIV: 'economyClassLabel',
  DIB: 'emeraldClassLabel',
  'EC+': 'alizeeClassLabel',
  ECO: 'economyClassLabel',
  FIR: 'firstClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_19__[/* momentFromApiDate */ "h"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_19__[/* momentFromApiDate */ "h"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_19__[/* momentFromApiTime */ "i"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') {
    var _i18n$common, _i18n$common$transpor;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  }

  if (way === 'OUTBOUND') {
    var _i18n$common2, _i18n$common2$transpo;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  }

  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_13___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_13___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'connectionDurationInMin');

    var stopOverDuration = lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'stopDurationInMin');

    var information = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(stopOverDuration) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'transport.reference'),
      type: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'transport.type'),
      information: information,
      operator: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'transport.companyOperator.label'),
      operatorId: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'transport.companyOperator.id'),
      operatorLogo: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'transport.companyOperator.logo'),
      start: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'departure.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'departure.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'departure.date')
      },
      end: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'arrival.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'arrival.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'arrival.date')
      },
      technicalStops: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportPlaneTicket(inboundFlight, outboundFlight) {
  return hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(inboundFlight, 'travelSections')) && hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(outboundFlight, 'travelSections'));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(inboundFlight, 'travelSections')) && hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(inboundFlight, 'travelSections')) && hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(travelSections) ? (travelSections || []).some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(section, 'arrival.time') || lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(inboundFlight, 'travelSections')) || tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var numberMinutes = Number(minutes);
  var time = [Math.floor(numberMinutes / 60), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('options.countdownLabels.hours'), "".concat(isRTL ? '-' : ''), (numberMinutes % 60).toString().padStart(2, '0'), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('options.countdownLabels.min')];
  return time.join(' ');
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$inbound2, _transport$outbound; // in case of AlternativeTransport


  if ((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isCharterFlight */ "x"])(((_transport$inbound$jo = transport.inbound.journey) === null || _transport$inbound$jo === void 0 ? void 0 : _transport$inbound$jo.cancellationPolicyType) || '') || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.some(function (outbound) {
        var _outbound$journey;

        return (// $FlowFixMe at this point it's an AlternativeTransport object
          Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isCharterFlight */ "x"])(((_outbound$journey = outbound.journey) === null || _outbound$journey === void 0 ? void 0 : _outbound$journey.cancellationPolicyType) || '')
        );
      })
    );
  } // in case of Transport


  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isCharterFlight */ "x"])(((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* isCharterFlight */ "x"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound3, _transport$inbound4, _transport$outbound2; // in case of AlternativeTransport


  if ((_transport$inbound3 = transport.inbound) === null || _transport$inbound3 === void 0 ? void 0 : _transport$inbound3.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo2;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      ((_transport$inbound$jo2 = transport.inbound.journey) === null || _transport$inbound$jo2 === void 0 ? void 0 : _transport$inbound$jo2.cancellationPolicyType) || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.find(function (outbound) {
        var _outbound$journey2;

        return !!((_outbound$journey2 = outbound.journey) === null || _outbound$journey2 === void 0 ? void 0 : _outbound$journey2.cancellationPolicyType);
      })
    );
  } // in case of Transport
  // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound4 = transport.inbound) === null || _transport$inbound4 === void 0 ? void 0 : _transport$inbound4.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getNDCCancelationPolicyDescription = function getNDCCancelationPolicyDescription(transports, i18n) {
  var cancellationPolicy = getCancellationPolicy(transports);

  if (cancellationPolicy === _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_18__[/* LEGAL_INFO_NDC_ID */ "c"]) {
    var _getOptinsInfos, _getOptinsInfos$ndc;

    return (_getOptinsInfos = Object(_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_15__[/* getOptinsInfos */ "k"])(i18n === null || i18n === void 0 ? void 0 : i18n.bookingProcess)) === null || _getOptinsInfos === void 0 ? void 0 : (_getOptinsInfos$ndc = _getOptinsInfos.ndc) === null || _getOptinsInfos$ndc === void 0 ? void 0 : _getOptinsInfos$ndc.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;

  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ })

}]);